import { useNavigate } from "react-router-dom";
import { mapDashboardMetricToDrilldown } from "@cmts/dashboard/cmtsDashboardDrilldownMapper.js";
import { SwotKpiCard } from "@swot-shared/dashboard/index.js";

export type CmtsDashboardDrilldownLinkProps = {
  readonly metricKey: string;
  readonly label: string;
  readonly value: string | number;
  readonly description?: string | undefined;
  readonly trend?: string | undefined;
  readonly scope?: Record<string, string | number | boolean | undefined | null> | undefined;
  readonly disabled?: boolean | undefined;
};

export function CmtsDashboardDrilldownLink(props: CmtsDashboardDrilldownLinkProps) {
  const navigate = useNavigate();
  const mapping = mapDashboardMetricToDrilldown(props.metricKey, props.scope ?? {});
  return (
    <SwotKpiCard
      label={props.label}
      value={props.value}
      trend={props.trend}
      description={props.description ?? mapping.reason}
      disabled={props.disabled || !mapping.enabled}
      onClick={mapping.enabled ? () => navigate(mapping.path) : undefined}
    />
  );
}
